import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, ArrowDown } from 'lucide-react';
export function ProblemSection() {
  return <section className="px-4 py-20 max-w-3xl mx-auto" data-id="element-158">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="space-y-12" data-id="element-159">
        {/* The Real Problem */}
        <div className="text-center" data-id="element-160">
          <div className="inline-flex items-center justify-center p-3 bg-brand-yellow/10 rounded-full mb-6" data-id="element-161">
            <AlertTriangle className="text-brand-yellow w-8 h-8" data-id="element-162" />
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-6 leading-tight" data-id="element-163">
            El problema real no es que no tengas ideas
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-164">
            El problema real es que estás haciendo esto:
          </p>
          <div className="my-8 font-display text-2xl md:text-3xl text-white font-bold bg-brand-surface p-6 rounded-lg border border-gray-800 inline-block" data-id="element-165">
            Consumir información <span className="text-gray-500" data-id="element-166">→</span>{' '}
            Guardar ideas <span className="text-gray-500" data-id="element-167">→</span> Sentirte peor{' '}
            <span className="text-gray-500" data-id="element-168">→</span> No ejecutar.
          </div>
        </div>

        {/* The Gap */}
        <div className="bg-brand-surface p-8 md:p-10 rounded-2xl border-l-4 border-brand-yellow" data-id="element-169">
          <h3 className="font-display text-2xl font-bold text-white mb-4" data-id="element-170">
            Porque nadie te da lo que realmente necesitas:
          </h3>
          <ul className="space-y-4 text-lg text-gray-300 mb-8" data-id="element-171">
            <li className="flex items-center gap-3" data-id="element-172">
              <span className="w-2 h-2 bg-brand-yellow rounded-full" data-id="element-173"></span>
              Qué elegir (sin pensarlo 2 semanas)
            </li>
            <li className="flex items-center gap-3" data-id="element-174">
              <span className="w-2 h-2 bg-brand-yellow rounded-full" data-id="element-175"></span>
              Qué publicar (sin inventar texto)
            </li>
            <li className="flex items-center gap-3" data-id="element-176">
              <span className="w-2 h-2 bg-brand-yellow rounded-full" data-id="element-177"></span>
              Cómo responder (sin quedarte en blanco)
            </li>
            <li className="flex items-center gap-3" data-id="element-178">
              <span className="w-2 h-2 bg-brand-yellow rounded-full" data-id="element-179"></span>
              Cómo cerrar (sin rogar)
            </li>
          </ul>
          <p className="text-white font-medium text-lg border-t border-gray-700 pt-6" data-id="element-180">
            Y sin eso, no hay ingreso extra.{' '}
            <span className="text-red-400" data-id="element-181">Solo hay ansiedad.</span>
          </p>
        </div>

        {/* Why old solutions fail */}
        <div className="text-center pt-8" data-id="element-182">
          <h3 className="font-display text-3xl font-bold text-white mb-6" data-id="element-183">
            Por qué lo que ya intentaste no funcionó
          </h3>
          <p className="text-gray-400 text-lg mb-8" data-id="element-184">
            Porque te daban piezas sueltas: "Haz contenido", "Vende un
            servicio", "Sé constante". Pero nunca te dieron el puente entre{' '}
            <span className="text-white font-bold" data-id="element-185">"quiero"</span> y{' '}
            <span className="text-brand-yellow font-bold" data-id="element-186">"me pagaron"</span>.
          </p>

          <div className="flex justify-center" data-id="element-187">
            <ArrowDown className="text-brand-yellow animate-bounce w-10 h-10" data-id="element-188" />
          </div>
        </div>
      </motion.div>
    </section>;
}